"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * <p>
 *     Binding of {@link PromotionArea master area} to {@link Promotion promotion}.
 *     Data should be exported to external system according to business rules defined within referenced document.
 * </p>
 *
 * <p><b>Name of the entity may be misleading. 'PromotionArea' would be more appropriate (but it is taken).</b></p>
 *
 * @see https://docs.google.com/document/d/1O1pGnej0tFOkh3IH8VOE5K435IgPdRg38NorATIRJ50/edit
 * @see {@link PromotionArea}
 * @author OPt
 */


var PromotionAreaBinding =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(PromotionAreaBinding, _DomainObject_1$Domai);

  /**
   * Binding of the {@link Promotion promotion} and {@link PromotionArea master area}. Binding forms so called promotion area.
   * @param id Internal id.
   * @param promotionId Corresponds to {@link Promotion promotion}.
   * @param promotionAreaId Corresponds to {@link PromotionArea.id}.
   */
  function PromotionAreaBinding(id, promotionId, promotionAreaId) {
    var _this;

    _classCallCheck(this, PromotionAreaBinding);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionAreaBinding).call(this));
    _this.id = id;
    _this.promotionId = promotionId;
    _this.promotionAreaId = promotionAreaId;
    return _this;
  }

  return PromotionAreaBinding;
}(DomainObject_1.DomainObject);

exports.PromotionAreaBinding = PromotionAreaBinding;

PromotionAreaBinding.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(PromotionAreaBinding.name);
  return {
    id: builder.id('id'),
    promotionId: builder.str('promotionId'),
    promotionAreaId: builder.str('promotionAreaId')
  };
}();